import RestClient from './RestClient';
import { Application } from '../../models';

class Applications extends RestClient {
    constructor() {
        super({
            "model": Application,
            "entryPoint": "application",
            "resource": "application",
            "resources": "applications",
            "id": "id"
        });
    }

    accept(id) {
        return this.PUT(`/application/accept/${id}`)
            .then(response => response.json())
            .then(json => {
                if (json.application) {
                    json.application = new Application(json.application);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    reject(id) {
        return this.PUT(`/application/reject/${id}`)
            .then(response => response.json())
            .then(json => {
                if (json.application) {
                    json.application = new Application(json.application);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    unsubmit(id) {
        return this.PUT(`/application/unsubmit/${id}`)
            .then(response => response.json())
            .then(json => {
                if (json.application) {
                    json.application = new Application(json.application);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    enroll(payload) {
        return this.POST('/application/enroll', payload)
            .then(response => this.parseResponseJson(response))
            .then(json => {
                if (json.application) {
                    json.application = new Application(json.application);
                    return json;
                }
                throw new Error(json.flash?.error || 'enroll failed');
            });
    }

    previewEnroll(typeId, userIds) {
        return this.POST('/application/preview_enroll', {
            type_id: typeId,
            user_ids: userIds,
        })
            .then(response => this.parseResponseJson(response))
            .then(json => {
                if (json.preview) {
                    return json.preview;
                }
                throw new Error(json.flash?.error || 'preview failed');
            });
    }

    enrollBatch(payload) {
        return this.POST('/application/enroll_batch', payload)
            .then(response => this.parseResponseJson(response))
            .then(json => {
                if (json.batch) {
                    return json.batch;
                }
                throw new Error(json.flash?.error || 'enroll batch failed');
            });
    }
}

const ApplicationsApi = new Applications();

export default ApplicationsApi;
